<template lang="pug">
  div.fill-height
    SubHeader
    v-dialog(v-model='show_pet', max-width='500')
      ViewPet(:show_pet='show_pet', :pet='pet_selected')
    v-container.fill-height(fluid='')
      v-row(align='center', justify='center')
        v-col(v-for='pet in pets', cols='12', md='4', :key='pet.id')
          CardItem(:item='pet', :actions='actions')
</template>

<script>
// @ is an alias to /src
import CardItem from '@/components/CardItem.vue'
import SubHeader from '@/components/SubHeader.vue'
import ViewPet from '@/components/pets/ViewPet.vue'

export default {
  name: 'Adopt',
  components: {
    ViewPet,
    CardItem,
    SubHeader,
  },
  data() {
    return {
      pet_selected: {},
      show_pet: false,
      pets: [
        {
          id: 1,
          name: 'Tony',
          description: 'Soy Tony',
          picture: 'http://micropetid.com/assets/images/ga.jpg'
        },
        {
          id: 2,
          name: 'Amy',
          description: 'Soy Amy',
          picture: 'http://micropetid.com/assets/images/ga1.jpg'
        },
        {
          id: 3,
          name: 'Nube',
          description: 'Soy Nube',
          picture: 'http://micropetid.com/assets/images/ga2.jpg'
        },
        {
          id: 4,
          name: 'Orion',
          description: 'Soy Orion',
          picture: 'http://micropetid.com/assets/images/ga3.jpg'
        },
        {
          id: 5,
          name: 'Lupe',
          description: 'Soy Lupe',
          picture: 'http://micropetid.com/assets/images/ga5.jpg'
        },
        {
          id: 6,
          name: '',
          description: 'Soy hembra de 4 años, me encuentro esterilizada, soy victima de maltrato del ser humano, Busco un hermoso hogar y tengo mucho amor para dar.',
          picture: 'http://micropetid.com/assets/images/ga4.jpg'
        },
        {
          id: 7,
          name: 'Barman',
          description: 'Soy Barman',
          picture: 'http://micropetid.com/assets/images/ga6.jpg'
        },
        {
          id: 8,
          name: 'Máz',
          description: 'Soy Máz',
          picture: 'http://micropetid.com/assets/images/ga7.jpg'
        },
        {
          id: 9,
          name: 'Feliciano',
          description: 'Soy Feliciano',
          picture: 'http://micropetid.com/assets/images/ga8.jpg'
        }
      ],
      actions: {
        view: (id) => {
          this.pet_selected = this.pets.filter(pet => pet.id === id)[0];
          this.show_pet = true;
        }
      }
    }
  },
}
</script>
